<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> View/Print Minutes </h6>
<div class="card" >
    <div class="card-body" *ngIf='displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />
<div class="row" *ngIf='displayState.gridDiv'>
    <div class="col-md-10 offset-1">
      <p-table [value]="hearingDateList" [scrollable]="true" scrollHeight="570px"  >
        <ng-template pTemplate="header">
            <tr style="font-size:medium;">
                <th style="width: 20%;">Hearing Date</th>
                <th style="width: 20%;">Hearing Time</th>
                <th style="width: 10%;" >&nbsp;</th>
                <th style="width: 10%;" >&nbsp;</th>
                <th style="width: 10%;" >&nbsp;</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-hearing>
            <tr style="font-size: small;">
                <td style="width: 20%;">{{hearing.hearingDate | date:"MM/dd/yyyy"}}</td>
                <td style="width: 20%;">{{hearing.hearingTime}}</td>
              <td style="width: 5%;">
                  <button class='btn btn-sm btn-link' (click)="onSelectHearing(hearing)">View</button>
              </td>
              <td style="width: 10%;">
                <button class='btn btn-sm btn-link' (click)="onSelectMinuteOrder(hearing)">Print Minute Orders</button>
              </td>
              <td style="width: 10%;">
                <button class='btn btn-sm btn-link' (click)="onSelectMinuteOrderLabels(hearing)">Labels</button>
              </td>
              </tr>
        </ng-template>
      </p-table>
    </div>
</div>
